import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
// import './HlzTeams.css';
import './Products.css';
import { tpCtrlBdData } from "../assets/ProductsData";

function ProductTpCtrlBd() {
  // console.log("get into ProductTpCtrlBd()");
  return (
    <section id='touchctrl' className='touchctrlbd-block'>
      <div className='title-holder text-center'>
        <h1 className='prodtpctrlbd'>Product/Touch Control Board</h1>
        <h2>HLZ Touch Controller</h2>
        <div className='fs-4'>Some of our Touch Controller</div>
      </div>
      <Container fluid className='d-flex'>
        {/* <Container fluid className='d-flex'> */}
        <Row>
          { tpCtrlBdData.map(ctrlr => {
            return (
              <Col sm={4} key={ctrlr.id}>
                <Row className='image'>
                  {/* <Row className='image d-flex justify-content-center'> */}
                  <Image src={ctrlr.image} alt={ctrlr.alt} />
                  <div className='overlay'> <div className='socials'> </div> </div>
                  {/* <Row className='image'> */}
                  {/* <Image style={{ height: '25vh' }} src={ctrlr.image} alt={ctrlr.alt} /> */}
                  {/* <Image style={{ height: '25vh' }} src={ctrlr.image} alt="Image" /> */}
                  {/* <img style={{ height: '40vh' }} src={ctrlr.image} className='mt-5 mt-lg-0' alt="" /> */}
                  {/* <Row> */}
                </Row>
                <div className='text-center'>
                  <p className='fs-3'>{ctrlr.title}</p>
                  <p className='fs-4'>{ctrlr.describe}</p>
                  <p className='fs-5 text-start'>{ctrlr.text}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default ProductTpCtrlBd;